import Navbar from "../components/Navbar";

function Services() {
  return (
    <div>
      <Navbar />
      <h1>Services Page</h1>
    </div>
  );
}

export default Services;